import { useQuery } from '@tanstack/react-query';
import { fetchArenaCurrentSeason } from '../../../../api/apiServices';

const useFetchArenaCurrentSeason = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['arenaCurrentSeason'],
    queryFn: fetchArenaCurrentSeason,
  });

  return {
    refetch,
    isLoading,
    data,
  };
};

export default useFetchArenaCurrentSeason;
